import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from './PopupBox.js';

import Form from 'react-bootstrap/Form';
import IntroPopup from './IntroPopup.js';


export default class About extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
        stuff: 0,
        message: "",
        buttons: []
    };
  }




  randomFailMessage()
  {
    var contents = ["Thanks for your data", "Thanks for your data", "Thanks for your data", "Mmmm Tasty data", "Yum", "Thanks for sharing", ":)"]
    
    return contents[Math.floor(Math.random()*contents.length)];
  }


  randomSuccessMessage()
  {
    var contents = ["No data received", "You did not share data", ":("]
    
    return contents[Math.floor(Math.random()*contents.length)];
  }


  randomContent()
  {
    var contents = ["SKIP AD", "FREE trial", "AGREE", "sign up now!", "download now!", "CLICK CLICK CLICK CLICK!!!", "Accept", "closing in.."]
    
    return contents[Math.floor(Math.random()*contents.length)];
  }

  randomVariant()
  {
    var variants = ["dark", "light"]
    
    return variants[Math.floor(Math.random()*variants.length)]

  }

  randomSize()
  {
    var size = (Math.random()*1.8) * (Math.random()*2) * (Math.random()*2)  + 0.6

   

    return size

  }

  createButton(content_override)
  {

    
   

    if(content_override == "The End")
    {
        return <div></div>
    }


    var left = Math.random()*window.innerWidth*1.3 - window.innerWidth*0.2;
    var top = Math.random()*window.innerHeight*1.3 - window.innerHeight*0.2;

    var content =  this.randomContent()


    var variant = this.randomVariant()



    if(content_override != "")
    {
        content = content_override

        if(content_override == "No personal data received")
        {
            variant = "secondary"
        }
        if(content_override == "Thanks for your data")
        {
            variant = "info"
        }

    

        console.log("content_override", content_override)

        //variant = "secondary"
        
    }

    if(this.state.message != content_override)
    {
        this.setState({
            message: content_override
        })
    }

    var size = this.randomSize()

   

    var button = {
        variant: variant,
        left: left,
        top: top,
        size: size,
        content: content
    }


    return button

  }

  componentDidMount() {


    var buttons = []

    for(var i = 0; i < 40; i ++)
    {

        buttons.push(this.createButton(""))

    }


    this.setState({
        buttons: buttons
    })

    

    this.interval = setInterval(() => {

        //console.log(this.props)

        if(this.props.getMessage() == "")
        {

            for(var i = 0; i < 13; i ++)
            {

               
                    var buttons = this.state.buttons.slice(0)

                    var random_button = Math.floor(Math.random()*this.state.buttons.length)

                    

                    if(buttons[random_button].variant == "info" || buttons[random_button].variant == "secondary")
                    {
                        buttons[random_button].content = this.randomContent()

                        buttons[random_button].variant = this.randomVariant()

                        //buttons[random_button].size = 0

                        buttons[random_button].left = Math.random()*window.innerWidth*1.3 - window.innerWidth*0.2;
                        buttons[random_button].top = Math.random()*window.innerHeight*1.3 - window.innerHeight*0.2;
                    }

                  


                    
                    this.setState({
            
                        buttons: buttons
            
                    })

                
               

            }

        }

        else
        {
            

            for(var i = 0; i < 18; i ++)
            {
        
                var buttons = this.state.buttons.slice(0)

                var random_button = Math.floor(Math.random()*this.state.buttons.length)
        
               

                if(this.props.getMessage() == "jiggle")
                {
                    if(Math.random()*10 < 2.7)
                    {
                        buttons[random_button].content = this.randomContent()

                        buttons[random_button].variant = this.randomVariant()
    
                        buttons[random_button].size = this.randomSize()
    
                        buttons[random_button].left = Math.random()*window.innerWidth*1.3 - window.innerWidth*0.2;
                        buttons[random_button].top = Math.random()*window.innerHeight*1.3 - window.innerHeight*0.2;
                    }
                    
                }
                

                

                if(this.props.getMessage() == "No personal data received")
                {

                    if(buttons[random_button].variant != "secondary")
                    {
                        buttons[random_button].size = this.randomSize()
                        buttons[random_button].variant = "secondary"
                        buttons[random_button].content = this.randomSuccessMessage()
                        buttons[random_button].randomVariant = this.randomVariant()
                    }
                    
                }
                if(this.props.getMessage() == "Thanks for your data")
                {
                    if(buttons[random_button].variant != "info")
                    {
                        buttons[random_button].size = this.randomSize()
                        buttons[random_button].variant = "info"
                        buttons[random_button].content = this.randomFailMessage()
                        
                    }
                }
        
                if(this.props.getMessage() == "The End")
                {
                    buttons[random_button].size = 0
                }
               
                
                
                this.setState({
        
                    buttons: buttons
        
                })
        
            }

        }

       


    }, 120);


  }


componentWillUnmount() {
    clearInterval(this.interval);
  }






  render() {

   
    var content = ""

    for(var i = 0; i < 1000; i ++)
    {
        content += this.state.message
    }

  

    var buttons = []

    for(var i = 0; i < this.state.buttons.length; i ++)
    {
        var this_button = this.state.buttons[i]


        var variant_override = this_button.variant

        if(variant_override == "info")
        {
            //variant_override = "dark"
        }
    
        if(variant_override == "secondary")
        {
            //variant_override = "light"
        }



        var button = <Button className="bad-button m-5" variant={variant_override} size="lg" style={{
            position: "fixed",
            left: this_button.left,
            top: this_button.top,
            transform: "scale("+this_button.size+","+this_button.size+")",
        }}>{this_button.content}</Button>


        buttons.push(button)

    }


    return (
        <div class="bad-design-bg">



        <div class="bad-design">

     

        {buttons}

               

        </div>

        </div>
    );
  }
}
